// Login.js
import React, { useState } from 'react'
import supabase from './supabaseClient'
import { Link } from 'react-router-dom';


export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [message, setMessage] = useState('')

  const handleLogin = async () => {
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setMessage('Ошибка входа: ' + error.message)
    else setMessage('Вход выполнен')
  }

  return (
    <div style={{ maxWidth: 400, margin: 'auto', padding: '2rem' }}>
      <h2>Вход в ClearMatch</h2>
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ width: '100%', marginBottom: 10 }}
      />

      <input
        type="password"
        placeholder="Пароль"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ width: '100%', marginBottom: 10 }}
      />
      <button onClick={handleLogin}>Войти</button>
      <p>{message}</p>
      <p style={{ marginTop: 10 }}>
  Нет аккаунта? <Link to="/register">Зарегистрироваться</Link>
</p>


    </div>
  )
}
